var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransferPicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 179,
    viewBox: "0 0 261 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_470_51486)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261,
    height: 179,
    rx: 8,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.922 76.5784C246.922 76.3319 247.956 75.099 248.163 74.8524L247.956 73.6195C248.301 73.0442 249.032 71.8442 249.198 71.6469C249.405 71.4004 250.439 71.6469 250.646 71.6469C250.853 71.6469 251.68 72.6332 252.094 72.8798C252.508 73.1264 252.922 75.099 252.922 75.5921C252.922 76.0853 252.922 77.5648 252.715 77.8113C252.508 78.0579 251.887 79.0442 251.68 79.2908C251.474 79.5374 250.646 79.5374 250.439 79.5374C250.232 79.5374 248.991 79.2908 248.784 79.2908C248.618 79.2908 247.749 78.4689 247.336 78.0579C247.198 77.6469 246.922 76.7757 246.922 76.5784Z",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.922 119.578C128.922 119.332 130.129 118.099 130.37 117.852L130.129 116.62C130.531 116.044 131.384 114.844 131.577 114.647C131.818 114.4 133.025 114.647 133.267 114.647C133.508 114.647 134.474 115.633 134.956 115.88C135.439 116.126 135.922 118.099 135.922 118.592C135.922 119.085 135.922 120.565 135.68 120.811C135.439 121.058 134.715 122.044 134.474 122.291C134.232 122.537 133.267 122.537 133.025 122.537C132.784 122.537 131.336 122.291 131.094 122.291C130.901 122.291 129.887 121.469 129.405 121.058C129.244 120.647 128.922 119.776 128.922 119.578Z",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-150.086 165.663L-150.086 160.273L-133.056 160.273C-132.058 156.186 -128.841 152.969 -124.754 151.971L-124.754 118.23L-150.086 118.23L-150.086 112.84L-124.754 112.84L-124.754 79.0989C-128.841 78.101 -132.058 74.8841 -133.056 70.7972L-150.086 70.7972L-150.086 65.4071L-133.056 65.4071C-132.058 61.3203 -128.841 58.1036 -124.754 57.1057L-124.754 23.3645L-150.086 23.3645L-150.086 17.9744L-124.754 17.9744L-124.754 -2.50818L-119.364 -2.50818L-119.364 17.9744L-51.9883 17.9744L-51.9883 -2.50794L-46.5982 -2.50794L-46.5982 17.9744L20.7851 17.9744L20.7851 -2.50794L26.1752 -2.50794L26.1752 17.9744L93.5508 17.9744L93.5508 -2.50781L98.9409 -2.50781L98.9409 17.9744L281.121 17.9744L281.121 23.3645L98.9409 23.3645L98.9409 65.3813L251.512 140.166L283.636 65.4863L288.587 67.6162L256.358 142.541L284.062 156.121L281.69 160.961L254.225 147.499L239.177 182.482L263.87 194.585L261.497 199.425L237.045 187.439L232.174 198.762L227.223 196.632L232.199 185.064L187.162 162.989L173.955 193.691L169.004 191.561L182.316 160.613L137.031 138.416L111.073 198.762L106.121 196.632L119.403 165.756L98.9409 165.756L98.9409 191.536L93.5508 191.536L93.5508 165.756L34.4526 165.756C33.4288 169.798 30.2304 172.973 26.1752 173.964L26.1752 191.536L20.7852 191.536L20.7852 173.964C16.6981 172.966 13.4809 169.749 12.4829 165.662L-38.2938 165.662C-39.2921 169.75 -42.5102 172.967 -46.5982 173.965L-46.5982 191.536L-51.9883 191.536L-51.9883 173.963C-56.0734 172.964 -59.2888 169.748 -60.2866 165.662L-111.063 165.662C-112.061 169.749 -115.278 172.966 -119.364 173.964L-119.364 191.536L-124.754 191.536L-124.754 173.964C-128.841 172.967 -132.058 169.75 -133.056 165.663L-150.086 165.663ZM93.5508 160.422L34.511 160.422C33.5556 156.265 30.3109 152.982 26.1752 151.972L26.1752 118.23L93.5462 118.23L93.5462 112.84L26.1752 112.84L26.1752 79.0985C30.2614 78.1001 33.4777 74.8835 34.4757 70.7972L93.5446 70.7972L93.5446 65.4071L34.4757 65.4071C33.4776 61.3209 30.2613 58.1045 26.1752 57.1061L26.1752 23.3645L93.5508 23.3645L93.5508 160.422ZM20.7852 118.23L20.7852 151.971C16.6983 152.969 13.4813 156.186 12.483 160.272L-38.2938 160.272C-39.2922 156.185 -42.5102 152.968 -46.5982 151.97L-46.5982 118.23L20.7852 118.23ZM20.7852 79.0989C16.6982 78.101 13.4811 74.8841 12.4829 70.7972L-38.2937 70.7972C-39.2919 74.885 -42.5101 78.1024 -46.5982 79.0997L-46.5982 112.84L20.7852 112.84L20.7852 79.0989ZM12.483 65.4071C13.4812 61.3204 16.6983 58.1036 20.7852 57.1057L20.7851 23.3645L-46.5982 23.3645L-46.5982 57.1054C-42.5103 58.1026 -39.2923 61.3198 -38.2939 65.4071L12.483 65.4071ZM-111.063 160.272C-112.062 156.186 -115.278 152.97 -119.364 151.972L-119.364 118.23L-51.9883 118.23L-51.9883 151.972C-56.0733 152.971 -59.2887 156.187 -60.2865 160.272L-111.063 160.272ZM-119.364 79.0985L-119.364 112.84L-51.9883 112.84L-51.9883 79.0982C-56.0735 78.0992 -59.2889 74.8829 -60.2867 70.7972L-111.063 70.7972C-112.061 74.8835 -115.278 78.1001 -119.364 79.0985ZM-111.063 65.4071L-60.2865 65.4071C-59.2885 61.3218 -56.0732 58.1058 -51.9883 57.1069L-51.9883 23.3645L-119.364 23.3645L-119.364 57.1061C-115.278 58.1045 -112.061 61.3209 -111.063 65.4071ZM249.379 145.124L234.331 180.106L189.295 158.031L204.343 123.048L249.379 145.124ZM199.497 120.673L184.449 155.656L139.163 133.458L154.211 98.4758L199.497 120.673ZM149.365 96.1005L134.317 131.083L98.9409 113.743L98.9409 71.3841L149.365 96.1005ZM98.9409 160.422L98.9409 119.746L132.185 136.041L121.697 160.422L98.9409 160.422ZM-49.2896 62.1732C-46.0151 62.1732 -43.3605 64.8277 -43.3605 68.1023C-43.3605 71.3768 -46.0151 74.0314 -49.2896 74.0314C-52.5642 74.0314 -55.2187 71.3768 -55.2187 68.1023C-55.2187 64.8277 -52.5642 62.1732 -49.2896 62.1732ZM-43.3605 162.967C-43.3605 159.693 -46.0151 157.038 -49.2897 157.038C-52.5642 157.038 -55.2188 159.693 -55.2188 162.967C-55.2188 166.242 -52.5642 168.897 -49.2897 168.897C-46.0151 168.897 -43.3605 166.242 -43.3605 162.967ZM-122.059 62.1734C-118.785 62.1734 -116.13 64.8279 -116.13 68.1025C-116.13 71.377 -118.785 74.0316 -122.059 74.0316C-125.334 74.0316 -127.988 71.377 -127.988 68.1025C-127.988 64.8279 -125.334 62.1734 -122.059 62.1734ZM-116.13 162.968C-116.13 159.693 -118.785 157.039 -122.059 157.039C-125.334 157.039 -127.988 159.693 -127.988 162.968C-127.988 166.242 -125.334 168.897 -122.059 168.897C-118.785 168.897 -116.13 166.242 -116.13 162.968ZM23.4799 62.1734C26.7544 62.1734 29.409 64.8279 29.409 68.1025C29.409 71.3771 26.7544 74.0316 23.4799 74.0316C20.2053 74.0316 17.5508 71.3771 17.5508 68.1025C17.5508 64.8279 20.2053 62.1734 23.4799 62.1734ZM29.409 162.968C29.409 159.693 26.7544 157.039 23.4799 157.039C20.2053 157.039 17.5508 159.693 17.5508 162.968C17.5508 166.242 20.2053 168.897 23.4799 168.897C26.7544 168.897 29.409 166.242 29.409 162.968ZM178.172 -2.50812L178.172 17.9742L183.562 17.9742L183.562 -2.50812L178.172 -2.50812Z",
    fill: "#2E0249"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.832,
    y: 120.062,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.832,
    y: 25.1963,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.832,
    y: 0.401611,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8398,
    y: 142.7,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8398,
    y: 47.835,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.7656,
    y: 120.062,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.7656,
    y: 25.1963,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.7656,
    y: 0.401611,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7773,
    y: 142.7,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7773,
    y: 47.835,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.6992,
    y: 120.062,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.6992,
    y: 25.1962,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.6992,
    y: 0.401611,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8.05469,
    y: 47.835,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8.05469,
    y: 142.7,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.707,
    y: 142.7,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.707,
    y: 47.835,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.12891,
    y: 25.1963,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.12891,
    y: 0.401611,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.12891,
    y: 120.062,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.6445,
    y: 120.062,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.6445,
    y: 25.1963,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.8125,
    y: 25.1963,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.8125,
    y: 120.062,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.5742,
    y: 120.062,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.5742,
    y: 25.1963,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.5742,
    y: 0.401611,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.87891,
    y: 47.835,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.87891,
    y: 142.7,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.6445,
    y: 142.7,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.6445,
    y: 47.835,
    width: 8.62415,
    height: 16.1703,
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.832,
    y: 110.899,
    width: 16.1703,
    height: 8.62415,
    transform: "rotate(-90 31.832 110.899)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.6992,
    y: 89.3386,
    width: 16.1703,
    height: 8.62415,
    transform: "rotate(-90 57.6992 89.3386)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8398,
    y: 185.282,
    width: 16.1703,
    height: 8.62415,
    transform: "rotate(-90 38.8398 185.282)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.87891,
    y: 185.282,
    width: 16.1703,
    height: 8.62415,
    transform: "rotate(-90 4.87891 185.282)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.6445,
    y: 185.282,
    width: 16.1703,
    height: 8.62415,
    transform: "rotate(-90 77.6445 185.282)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8.05469,
    y: 185.282,
    width: 16.1703,
    height: 8.62415,
    transform: "rotate(-90 -8.05469 185.282)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.707,
    y: 185.282,
    width: 16.1703,
    height: 8.62415,
    transform: "rotate(-90 64.707 185.282)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7773,
    y: 185.282,
    width: 16.1703,
    height: 8.62415,
    transform: "rotate(-90 51.7773 185.282)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.7656,
    y: 110.899,
    width: 16.1703,
    height: 8.62415,
    transform: "rotate(-90 44.7656 110.899)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.6445,
    y: 89.3386,
    width: 16.1703,
    height: 8.62415,
    transform: "rotate(-90 70.6445 89.3386)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.6055,
    y: 110.206,
    width: 15.5171,
    height: 21.8209,
    transform: "rotate(-90 57.6055 110.206)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.793,
    y: 109.721,
    width: 36.3682,
    height: 8.24347,
    transform: "rotate(-90 83.793 109.721)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.12891,
    y: 110.899,
    width: 16.1703,
    height: 21.5604,
    transform: "rotate(-90 -2.12891 110.899)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.156,
    y: 110.36,
    width: 11.8582,
    height: 13.4752,
    transform: "rotate(-153.442 142.156 110.36)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.781,
    y: 133.46,
    width: 6.83592,
    height: 13.4752,
    transform: "rotate(-156.204 192.781 133.46)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.68,
    y: 117.367,
    width: 8.36367,
    height: 13.4752,
    transform: "rotate(-156.204 159.68 117.367)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.266,
    y: 127.069,
    width: 11.8582,
    height: 13.4752,
    transform: "rotate(-153.442 135.266 127.069)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.684,
    y: 103.353,
    width: 11.8582,
    height: 13.4752,
    transform: "rotate(-153.442 128.684 103.353)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.793,
    y: 120.062,
    width: 11.8582,
    height: 13.4752,
    transform: "rotate(-153.442 121.793 120.062)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.84,
    y: 150.896,
    width: 26.3112,
    height: 10.9393,
    transform: "rotate(-155.01 184.84 150.896)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.172,
    y: 176.333,
    width: 26.3112,
    height: 32.3426,
    transform: "rotate(-155.01 235.172 176.333)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.102,
    y: 195.519,
    width: 33.6578,
    height: 32.3426,
    transform: "rotate(-156.357 276.102 195.519)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.816,
    y: 164.414,
    width: 17.6016,
    height: 32.3426,
    transform: "rotate(-155.01 209.816 164.414)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.984,
    y: 137.849,
    width: 9.70217,
    height: 8.08514,
    transform: "rotate(-90 102.984 137.849)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.984,
    y: 149.707,
    width: 9.70217,
    height: 15.0923,
    transform: "rotate(-90 102.984 149.707)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.984,
    y: 157.792,
    width: 5.9291,
    height: 15.0923,
    transform: "rotate(-90 102.984 157.792)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.984,
    y: 173.963,
    width: 5.9291,
    height: 8.08514,
    transform: "rotate(-90 102.984 173.963)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.203,
    y: 96.3455,
    width: 5.96603,
    height: 13.4752,
    transform: "rotate(-153.442 115.203 96.3455)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.539,
    y: 179.052,
    width: 10.2412,
    height: 14.5532,
    transform: "rotate(-66.9765 124.539 179.052)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.465,
    y: 165.037,
    width: 10.2412,
    height: 14.5532,
    transform: "rotate(-66.9765 130.465 165.037)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.5,
    y: 178.512,
    width: 10.2412,
    height: 14.5532,
    transform: "rotate(-66.9765 158.5 178.512)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.398,
    y: 151.562,
    width: 10.2412,
    height: 14.5532,
    transform: "rotate(-66.9765 136.398 151.562)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.43,
    y: 165.037,
    width: 10.2412,
    height: 14.5532,
    transform: "rotate(-66.9765 164.43 165.037)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.602,
    y: 16.5723,
    width: 16.1703,
    height: 28.5675,
    transform: "rotate(-90 104.602 16.5723)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.59,
    y: 16.5723,
    width: 16.1703,
    height: 9.16316,
    transform: "rotate(-90 249.59 16.5723)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.191,
    y: 16.5723,
    width: 16.1703,
    height: 9.16316,
    transform: "rotate(-90 237.191 16.5723)",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.176 27.1376L102.176 62.9817L250.134 134.4L284.9 57.0526L284.9 27.1375L102.176 27.1376Z",
    fill: "#EAE9F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.496,
    y: 65.3489,
    width: 79.1745,
    height: 5.39009,
    transform: "rotate(-67.5814 216.496 65.3489)",
    fill: "#2E0249"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.969,
    y: 18.3401,
    width: 177.961,
    height: 5.39009,
    transform: "rotate(23.9543 111.969 18.3401)",
    fill: "#2E0249"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 204.048,
    cy: 117.75,
    r: 7.75855,
    fill: "#FE346E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.293,
    cy: 117.507,
    r: 3.63682,
    fill: "#FE346E"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 70.2117,
    cy: 162.847,
    r: 7.75855,
    fill: "#FE346E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.4571,
    cy: 162.604,
    r: 3.63682,
    fill: "#FE346E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9219 115.5H96.5829C97.0534 115.5 97.5174 115.611 97.9372 115.823L136.259 135.212L183.423 158.196C184.933 158.932 186.754 158.284 187.46 156.759L204.924 118.995",
    stroke: "#FE346E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9219 162.537H119.316C121.484 162.537 122.936 164.767 122.06 166.75L108.453 197.537",
    stroke: "#FE346E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6928 20.7682L177.77 20.7682C179.427 20.7682 180.77 19.425 180.77 17.7682L180.77 -12.6906",
    stroke: "#FE346E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_470_51486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9844 114.037C42.9844 113.787 44.1302 112.537 44.3594 112.287L44.1302 111.037C44.5122 110.454 45.3219 109.237 45.5052 109.037C45.7344 108.787 46.8802 109.037 47.1094 109.037C47.3385 109.037 48.2552 110.037 48.7135 110.287C49.1719 110.537 49.6302 112.537 49.6302 113.037C49.6302 113.537 49.6302 115.037 49.401 115.287C49.1719 115.537 48.4844 116.537 48.2552 116.787C48.026 117.037 47.1094 117.037 46.8802 117.037C46.651 117.037 45.276 116.787 45.0469 116.787C44.8635 116.787 43.901 115.954 43.4427 115.537C43.2899 115.121 42.9844 114.237 42.9844 114.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4219 108.537C44.144 108.537 42.2969 110.552 42.2969 113.037C42.2969 115.122 43.5985 116.872 45.3631 117.382L46.4219 118.537L47.4806 117.382C49.2452 116.872 50.5469 115.122 50.5469 113.037C50.5469 110.552 48.6998 108.537 46.4219 108.537ZM46.4219 109.537C47.1827 109.537 47.7969 110.207 47.7969 111.037C47.7969 111.867 47.1827 112.537 46.4219 112.537C45.661 112.537 45.0469 111.867 45.0469 111.037C45.0469 110.207 45.661 109.537 46.4219 109.537ZM46.4219 116.687C45.276 116.687 44.2631 116.047 43.6719 115.077C43.6856 114.082 45.5052 113.537 46.4219 113.537C47.334 113.537 49.1581 114.082 49.1719 115.077C48.5806 116.047 47.5677 116.687 46.4219 116.687Z",
    fill: "#FE346E"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_470_51486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9844 19.0374C42.9844 18.7874 44.1302 17.5374 44.3594 17.2874L44.1302 16.0374C44.5122 15.454 45.3219 14.2374 45.5052 14.0374C45.7344 13.7874 46.8802 14.0374 47.1094 14.0374C47.3385 14.0374 48.2552 15.0374 48.7135 15.2874C49.1719 15.5374 49.6302 17.5374 49.6302 18.0374C49.6302 18.5374 49.6302 20.0374 49.401 20.2874C49.1719 20.5374 48.4844 21.5374 48.2552 21.7874C48.026 22.0374 47.1094 22.0374 46.8802 22.0374C46.651 22.0374 45.276 21.7874 45.0469 21.7874C44.8635 21.7874 43.901 20.954 43.4427 20.5374C43.2899 20.1207 42.9844 19.2374 42.9844 19.0374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4219 13.5374C44.144 13.5374 42.2969 15.5524 42.2969 18.0374C42.2969 20.1224 43.5985 21.8724 45.3631 22.3824L46.4219 23.5374L47.4806 22.3824C49.2452 21.8724 50.5469 20.1224 50.5469 18.0374C50.5469 15.5524 48.6998 13.5374 46.4219 13.5374ZM46.4219 14.5374C47.1827 14.5374 47.7969 15.2074 47.7969 16.0374C47.7969 16.8674 47.1827 17.5374 46.4219 17.5374C45.661 17.5374 45.0469 16.8674 45.0469 16.0374C45.0469 15.2074 45.661 14.5374 46.4219 14.5374ZM46.4219 21.6874C45.276 21.6874 44.2631 21.0474 43.6719 20.0774C43.6856 19.0824 45.5052 18.5374 46.4219 18.5374C47.334 18.5374 49.1581 19.0824 49.1719 20.0774C48.5806 21.0474 47.5677 21.6874 46.4219 21.6874Z",
    fill: "#FE346E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_470_51486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261,
    height: 179,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_470_51486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white",
    transform: "translate(40.9219 107.537)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_470_51486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white",
    transform: "translate(40.9219 12.5374)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferPicture);
export default __webpack_public_path__ + "static/media/transferPicture.e8f77eab1908aaf579aca1ea2f8d45b2.svg";
export { ForwardRef as ReactComponent };